import Vue from 'vue'
import Router from 'vue-router'
import Login from "../components/Login"
import Home from "../components/Home"
import mobileDetailed from "../components/mobileDetailed";

import LoginNew from "../components/LoginNew";
import HomeNew from "../components/HomeNew";

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: '/',
      name: 'login',
      component: Login
    },
    {
      path: '/home',
      name: 'home',
      component: Home
    },
    {
      path: '/mobileDetailed',
      name: 'mobileDetailed',
      component: mobileDetailed
    },
    {
      path:'/logon',
      name: 'loginNew',
      component: LoginNew
    },
    {
      path: '/main',
      name: 'homeNew',
      component: HomeNew
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js